import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import "./style.css";
import "../common.css";
import UserDetails from "./userdetails";
import { CreateUserForm } from "../CreateUser/createuserform";
import ParentChildDunsMapping from "../ParentChildDunsMapping/mapping";
import * as rolePermConsts from "../../../constants/RolePermissionConstants";
import { verifyAccessPermission } from "../../../utils/rolePermissionAccess";
import * as userManagementConstants from "../../../components/UserManagement/Common/usermanagementconst";
import { useVendorProfileLoader } from "../../Common/CustomHooks/useVendorProfileLoader";
import { checkOnBoardingStatus } from "../../../utils/utils";
import * as Constants from "../../../constants/Constants";
import AuditTrail from "../AuditTrail/audittrail";

const ManageUsers = () => {
  useVendorProfileLoader(); //To restore VendorProfile details in redux store on page reload

  const store = useSelector(
    ({ service, common }) => ({
      onboardingStatus: common.boardingStatuses?.onboardingStatus,
      roleName: service.roles?.roleName,
      isPrimaryVendor: service?.vendorProfile?.vendorDetail?.isPrimaryVendor,
      liveDate: service?.vendorProfile?.vendorDetail?.liveDate,
      merchandiseType: service?.vendorProfile?.vendorDetail?.merchandiseType,
      id: service?.vendorProfile?.vendorDetail?.id
    }),
    shallowEqual
  );
  const [subPage, setSubPage] = useState("");
  useEffect(() => {
    setSubPage(
      ["externalVendorGeneric"].includes(store?.roleName) ||
        store.onboardingStatus !== Constants.LIVE
        ? "manageDuns"
        : "manageUser"
    );
  }, [store]);

  const verifyParentChildDunsAccess = () => {
    const { onboardingStatus, roleName, isPrimaryVendor, liveDate, merchandiseType } = store;
    let isLiveVendor =
      (onboardingStatus !== ""  && merchandiseType != 'MP' &&
        checkOnBoardingStatus(onboardingStatus, [Constants.LIVE])) &&
      liveDate;
    if (
      [
        Constants.EXTERNAL_VENDOR_GENERIC,
        Constants.EXTERNAL_GENERIC_ADMIN,
      ].includes(roleName)
    ) {
      //external Vendors permission check and if live only then allowed access
      if (isLiveVendor && isPrimaryVendor) {
        return verifyAccessPermission("manageUsersParentChildDunsView");
      }
    } else {
      return verifyAccessPermission("manageUsersParentChildDunsView");
    }
    return false;
  };

  const loadComponent = () => {
    switch (subPage) {
      case "addUser":
        return (
          <div>
            {verifyAccessPermission("manageUsersAddUserEdit") &&
            store.onboardingStatus === Constants.LIVE ? (
              <CreateUserForm />
            ) : (
              <div className="cls-err">
                {store.onboardingStatus === Constants.LIVE &&
                  rolePermConsts.VMP_COMMON_PAGE_ACCESS_ERROR_MSG_PART1}
              </div>
            )}
          </div>
        );
      case "manageUser":
        return (
          <div>
            {verifyAccessPermission("manageUsersView") &&
            store.onboardingStatus === Constants.LIVE ? (
              <UserDetails />
            ) : (
              <div className="cls-err">
                {store.onboardingStatus === Constants.LIVE &&
                  rolePermConsts.VMP_COMMON_PAGE_ACCESS_ERROR_MSG_PART1}
              </div>
            )}
          </div>
        );
      case "manageDuns":
        return (
          <div>
            {verifyParentChildDunsAccess() ? (
              <ParentChildDunsMapping />
            ) : (
              <div className="cls-err">
                {store.onboardingStatus &&
                  rolePermConsts.VMP_COMMON_PAGE_ACCESS_ERROR_MSG_PART1}
              </div>
            )}
          </div>
        );
        case "auditTrail":
          return (
            <div>
              {store.roleName === 'sellerCentralAdmin' ? (
               <AuditTrail vendorId={store.id}/>
              ) : (
                <div className="cls-err">
                  {store.onboardingStatus &&
                    rolePermConsts.VMP_COMMON_PAGE_ACCESS_ERROR_MSG_PART1}
                </div>
              )}
            </div>
          );
      default:
        break;
    }
  };
  if (
    !verifyAccessPermission("manageUsersView") &&
    !verifyParentChildDunsAccess()
  ) {
    return (
      <div className="top-container">
        <div
          className="inner-container"
          style={{ justifyContent: "center", borderBottom: 0 }}
        >
          <div className="cls-err">
            {store.onboardingStatus === Constants.LIVE &&
              rolePermConsts.VMP_COMMON_PAGE_ACCESS_ERROR_MSG_PART1}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="top-container">
      <div className="inner-container">
        <div className="adduser">
          {verifyAccessPermission("manageUsersAddUserEdit") &&
            store.onboardingStatus === Constants.LIVE && (
              <button
                className={
                  subPage === "addUser" ? "mcy-btn-primary" : "inactive-tab"
                }
                onClick={() => {
                  setSubPage("addUser");
                }}
              >
                {userManagementConstants.ADD_USER}
              </button>
            )}
          {verifyAccessPermission("manageUsersView") &&
            store.onboardingStatus === Constants.LIVE && (
              <button
                className={
                  subPage === "manageUser" ? "mcy-btn-primary" : "inactive-tab"
                }
                onClick={() => {
                  setSubPage("manageUser");
                }}
              >
                {userManagementConstants.MANAGE_USERS}
              </button>
            )}
          {verifyParentChildDunsAccess() && (
            <button
              className={
                subPage === "manageDuns" ? "mcy-btn-primary" : "inactive-tab"
              }
              onClick={() => {
                setSubPage("manageDuns");
              }}
            >
              {userManagementConstants.MANAGE_PARENT_CHILD_DUNS}
            </button>
          )}
          {/* Audit Trail */}
          {store.roleName === 'sellerCentralAdmin' && <button
            className={
              subPage === "auditTrail" ? "mcy-btn-primary" : "inactive-tab"
            }
            onClick={() => {
              setSubPage("auditTrail");
            }}
          >
            {Constants.MANAGE_USER_AUDIT_TRAIL}
          </button>
          }
        </div>
      </div>
      <div className="user-container">{loadComponent()}</div>
    </div>
  );
};

export default ManageUsers;
